const KEY = 'hydrotools:project:v1';

export function createStorageService({ events, store, ui }) {
  function saveProject() {
    const state = store.getState();
    localStorage.setItem(KEY, JSON.stringify(state));
    ui.toast('Project saved');
    return state;
  }

  function loadProject() {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    try {
      const state = JSON.parse(raw);
      store.setState(state, { reason: 'loadProject' });
      ui.toast('Project loaded');
      return state;
    } catch (e) {
      console.error(e);
      ui.toast('Failed to load project');
      return null;
    }
  }

  function clearProject() {
    localStorage.removeItem(KEY);
    ui.toast('Saved project cleared');
  }

  return { saveProject, loadProject, clearProject };
}
